import { ConfigService } from '@app-core/services';
import { UserResponse } from '@app-model/login';
import { GetProductsRequest } from '@app-model/request';

import { CartItem } from './cart-item.model';

export class Cart {
  application: string;
  programId: string;
  userName: string;
  cmsDealerNumber: string;
  productForm: GetProductsRequest;
  products: CartItem[];

  constructor(products: CartItem[] = [], productForm?: GetProductsRequest, user: UserResponse = new UserResponse()) {
    this.application = ConfigService.getEnvironment().application;
    this.programId = user.programId;
    this.userName = user.userName;
    this.cmsDealerNumber = user.cmsDealerNumber;
    this.productForm = productForm;
    this.products = products;
  }
}
